import memoize from 'memoizee';
import { debounce } from 'lodash';
import {
  selectIsUnityInitializing,
  selectUnitySceneLoaded,
} from '../../../redux/slicers/configurator/configurator.slicer';
import { ONE_MINUTE, ONE_SECOND } from '../../../constants/constants';
import { getActiveHotspot, updateArtworkSet, updateHotspotProductJsonFile } from './moduleHelper';
import { getAppState } from '../../../redux/store';
import { UnityEvent, waitForEventOnce } from '../../../helpers/unityPubSub';
import {
  selectRoomLoadedCompletely,
  selectUnityLoaded,
} from '../../../redux/slicers/admin/curatorSlicer';
import { useRetailHotspot } from '../useRetailHotspot';
import { selectActiveSetDetails } from '../../../redux/slicers/retailAutomation/retailAutomation.slicer';

export const saveHotspotJson = async ({
  reason,
  delayed = true,
  jsonToBeSaved = null,
  waitForUpdate = false,
} = {}) => {
  // TODO: do not run the save working if the json is not updated
  const unityInitialized = selectRoomLoadedCompletely(getAppState());
  const unityLoaded = selectUnityLoaded(getAppState());
  if (!unityInitialized || !unityLoaded) {
    // we don't want to update hotspot json when unity initialization is in progress
    return;
  }
  const { activeHotspot } = selectActiveSetDetails(getAppState());
  const hotspotId = activeHotspot?.id;
  const hotspotJson =
    jsonToBeSaved ||
    (await waitForEventOnce(UnityEvent.GetRoomInfo, () =>
      window.roomModule.GetRedBullProjectJson()
    ));
  // updateArtworkSet({ payload: { id: hotspotId, json_file_content: hotspotJson }, isUpdate: false });
  // we have some delay before we save data on server
  const debouncedSaveHotspot = getDebouncedSaveHotspot(hotspotId);
  if (delayed) {
    debouncedSaveHotspot(hotspotJson);
  } else {
    debouncedSaveHotspot.cancel();
    const saveResult = await saveData({ hotspotId, hotspotJson, waitForUpdate });
    return saveResult;
  }
};

const saveData = async ({ hotspotId, hotspotJson, waitForUpdate = false }) => {
  const { activeHotspot } = selectActiveSetDetails(getAppState());
  const unityInitialized = selectRoomLoadedCompletely(getAppState());
  const unityLoaded = selectUnityLoaded(getAppState());
  if (!activeHotspot || !unityInitialized || !unityLoaded) return;
  // return updateArtworkSet({ payload: { id: hotspotId, json_file_content: hotspotJson } });
  // Removed return keyword as we are not using this data anywhere
  // return updateArtworkSet({ payload: { id: hotspotId, json_file_content: hotspotJson } });

  // Using updateHotspotProductJsonFile with hotspotJson to update the API instead of relying on GetRetailPropTransformInfo event
  if (waitForUpdate) {
    await Promise.all([
      updateHotspotProductJsonFile({ data: hotspotJson }),
      updateArtworkSet({ data: { id: hotspotId, json_file_content: hotspotJson } }),
    ]);
  } else {
    updateHotspotProductJsonFile({ data: hotspotJson });
    updateArtworkSet({ data: { id: hotspotId, json_file_content: hotspotJson } });
  }
};

const getDebouncedSaveHotspot = memoize(
  (hotspotId) => {
    return debounce((hotspotJson) => {
      saveData({ hotspotId, hotspotJson });
    }, 3 * ONE_SECOND);
  },
  { length: 1, maxAge: 2 * ONE_MINUTE }
);

export const saveHotspotJsonWithDelay300 = debounce(saveHotspotJson, 300);
export const saveHotspotJsonWithDelay500 = debounce(saveHotspotJson, 500);
export const saveHotspotJsonWithDelay1000 = debounce(saveHotspotJson, 1000);

// We are not using below function
// export const saveProductJsonWithDelay1000 = debounce((data) => {
//    updateHotspotProductJsonFile({ data });
//   }, 1000);